import { useState } from 'react';
import { useAuth } from '@/auth/AuthContext';
import { Badge } from '@/components/ui/primitives';
import { cn } from '@/lib/utils';

/** Account → Workspace switcher with role badge (brief §5.1). */
export function WorkspaceSwitcher() {
  const { user, activeWorkspace, switchWorkspace } = useAuth();
  const [open, setOpen] = useState(false);
  if (!user || !activeWorkspace) return null;

  return (
    <div className="relative min-w-0">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex min-w-0 max-w-full items-center gap-2 rounded-md px-2 py-1.5 text-sm hover:bg-hover"
      >
        <span className="flex h-6 w-6 items-center justify-center rounded bg-neutral-10 text-[11px] font-semibold text-neutral-0 dark:bg-neutral-11 dark:text-neutral-0">
          {activeWorkspace.name.slice(0, 1)}
        </span>
        <span className="max-w-[120px] truncate font-medium text-text-primary lg:max-w-[160px]">
          {activeWorkspace.name}
        </span>
        <span className="text-text-tertiary">▾</span>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} aria-hidden />
          <div className="absolute left-0 z-20 mt-1 w-64 rounded-lg border border-border-default bg-surface p-1.5 shadow-lg animate-fade-in">
            <div className="px-2 py-1 text-[11px] font-semibold uppercase tracking-wide text-text-tertiary">
              Workspaces
            </div>
            {user.workspaces.map((ws) => (
              <button
                key={ws.id}
                onClick={() => {
                  void switchWorkspace(ws.id);
                  setOpen(false);
                }}
                className={cn(
                  'flex w-full items-center justify-between rounded-md px-2 py-1.5 text-sm hover:bg-hover',
                  ws.id === activeWorkspace.id && 'bg-inset',
                )}
              >
                <span className="truncate text-text-primary">{ws.name}</span>
                <Badge tone={ws.role === 'owner' ? 'ai' : 'neutral'}>{ws.role}</Badge>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
